/**
 * XLM - Innovation & Technology | João Rodrigues | v2.0 | 2026*
 * 
 * Constantes usadas na anonimização (runRemoteNlp.tsx)
 */

//export const BATCH_SIZE = 61000;
//export const PARALLEL_LIMIT = 2; 
export const ALLOWED_TYPES = [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "text/plain",
    "application/msword"
];